import { render, staticRenderFns } from "./PicItem.vue?vue&type=template&id=790ba8fe&scoped=true&"
import script from "./PicItem.vue?vue&type=script&lang=ts&"
export * from "./PicItem.vue?vue&type=script&lang=ts&"
import style0 from "./PicItem.vue?vue&type=style&index=0&id=790ba8fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ba8fe",
  null
  
)

export default component.exports